import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var LifeBuoy = createReactComponent("LifeBuoy", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "14id60"
}], ["circle", {
  cx: "12",
  cy: "12",
  r: "4",
  key: "7pwehp"
}], ["line", {
  x1: "4.93",
  y1: "4.93",
  x2: "9.17",
  y2: "9.17",
  key: "ur3s5s"
}], ["line", {
  x1: "14.83",
  y1: "14.83",
  x2: "19.07",
  y2: "19.07",
  key: "1rakqz"
}], ["line", {
  x1: "14.83",
  y1: "9.17",
  x2: "19.07",
  y2: "4.93",
  key: "d8cfsg"
}], ["line", {
  x1: "14.83",
  y1: "9.17",
  x2: "18.36",
  y2: "5.64",
  key: "p16tkq"
}], ["line", {
  x1: "4.93",
  y1: "19.07",
  x2: "9.17",
  y2: "14.83",
  key: "13at7l"
}]]]);
export default LifeBuoy;